module.exports = __webpack_public_path__ + "static/media/IMG_3627.15a4a49f.jpg";